import { Intl } from 'temporal-polyfill';

type FormatOptionSet = {
    [formatName: string]: Intl.DateTimeFormatOptions;
};

export const LOCAL_TIME = {
    TIME_SHORT: {
        hour: 'numeric',
        minute: 'numeric',
    },
    DATE_SHORT: {
        day: 'numeric',
        month: 'numeric',
        year: '2-digit',
    },
    DATE_WEEKDAY_LONG: {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    },
    DATE_TIME_SHORT: {
        day: 'numeric',
        month: 'numeric',
        year: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
    },
    DATE_WEEKDAY_SHORT: {
        weekday: 'short',
        day: 'numeric',
        month: 'numeric',
        year: '2-digit',
    },
    DATE_TIME_WEEKDAY_SHORT: {
        weekday: 'short',
        day: 'numeric',
        month: 'numeric',
        year: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
    },
} satisfies FormatOptionSet;

export const ZONED_TIME = {
    DATE_TIME_SHORT: {
        ...LOCAL_TIME.DATE_TIME_SHORT,
        timeZoneName: 'short',
    },
    DATE_TIME_WEEKDAY_SHORT: {
        ...LOCAL_TIME.DATE_TIME_WEEKDAY_SHORT,
        timeZoneName: 'short',
    },
} satisfies FormatOptionSet;

/**
 * The default separator at least for en-GB and en-US is a dash but an arrow does look better so we need to find the dash to replace it
 * extra care has been taken here to make sure we're not replacing anything within part of a date itself.  If a locale separates with
 * something other than a dash this will simply not find it so they will just see their default separator
 */
export const isRangeSeparator = (part: Intl.DateTimeFormatRangePart): boolean => {
    // Take care '–' is not a standard dash it's a unicode character that looks just like one
    return part.type === 'literal' && part.source === 'shared' && part.value.trim() === '–';
};
